import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerUser} from '../../api/auth';
import { useAuth } from '../../auth/authContext';
import "./register.css";

export default function RegisterUser() {
    const nav = useNavigate();
    const { fetchMe } = useAuth();
    const [email, setEmail] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState<string | null>(null);

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErr(null);
        
        if (!email || !displayName || !password) {
            setErr("All fields are required");
            return;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setErr("Invalid email required.");
            return;
        }
        if (password.length < 6) {
            setErr("Password must be at least 6 characters.");
            return;
        }

        setBusy(true);
        try {
            const response = await registerUser(email, password, displayName);
            console.log(response);
            if (response === "Success") {
                await fetchMe();
                
                nav("/verification", { 
                    replace: true,
                    state: { email: email }
                });
            } else {
                await fetchMe();
                nav("/login", { replace: true});
            }
            //await fetchMe();
            //nav("/login", { replace: true});
        } catch (ex: any) {
            setErr(ex?.response?.data ?? "Registration failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className='register-container'>
            <form onSubmit={onSubmit}>
                <div className="register-grid">
                    <div>
                        <label className='labelText'>Email Address</label>
                        <div>
                            <input 
                                value={email} 
                                onChange={e=>setEmail(e.target.value)} 
                                placeholder='Email'
                                type="email"
                                className='inputField'
                                disabled={busy}
                            />
                        </div>
                    </div>
                    <div>
                        <label className='labelText'>Display Name</label>
                        <div>
                            <input 
                                value={displayName} 
                                onChange={e=>setDisplayName(e.target.value)} 
                                placeholder='Display Name'
                                className='inputField'
                                disabled={busy}
                            />
                        </div>
                    </div>
                    <div>
                        <label className='labelText'>Password</label>
                        <div>
                            <input 
                                type="password" 
                                value={password} 
                                onChange={e=>setPassword(e.target.value)} 
                                placeholder='Password'
                                className='inputField'
                                disabled={busy}
                            />
                        </div>
                        <label className='tint small'>Password must be at least 6 characters.</label>
                    </div>
                    {err && <div className="btn">{err}</div>}
                    <button 
                        disabled={busy}
                        className='btn '
                        type="submit"
                    >
                        {busy ? "Creating..." : "Create Account"}
                    </button>
                </div>
            </form>
        </div>
    );
}
